import { ITherapySuppliers } from 'Interfaces/therapySuppliers';
import * as yup from 'yup';

export const SuppliersSchema = yup.object().shape({
  supName: yup.string().nullable().default(null),
  specialty: yup.number().required(''),
  subSpecial: yup.number().nullable().default(null),
  area: yup.number().nullable().default(null),
  region: yup.number().nullable().default(null),
  city: yup.number().nullable().default(null),
  accessible: yup.boolean().nullable().default(null),
  lng: yup.array().of(yup.number().nullable().default(null)),
  gender: yup.number().nullable().default(null),
  treatMethod: yup.array().of(yup.number().required()),
  degree: yup.array().of(yup.number().nullable().default(null)),
  homeVisit: yup.boolean().nullable().default(null),
  institute: yup.boolean().nullable().default(null),
}) as yup.SchemaOf<ITherapySuppliers>;
